import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link as RouterLink } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { RECENT_MONTHLY_STATS_IMAGES } from "../constants/staticImageAssets";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MonthlyStatsPreview() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  const [selected, setSelected] = useState(null);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Monthly Server Stats
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        A snapshot of the server, month by month.
      </Typography>

      <Grid container spacing={3}>
        {RECENT_MONTHLY_STATS_IMAGES.map((month) => (
          <Grid item xs={12} sm={6} key={month.title}>
            <Paper
              variant="outlined"
              onClick={() => setSelected(month)}
              sx={{
                display: "block",
                overflow: "hidden",
                cursor: "pointer",
                transition: "box-shadow 0.2s ease",
                "&:hover": { boxShadow: 4 },
              }}
            >
              <Box
                component="img"
                src={month.thumbnailSrc}
                alt={month.title}
                loading="lazy"
                sx={{ width: "100%", height: "auto", display: "block" }}
              />
              <Box sx={{ px: 2, py: 1 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {month.title}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 2 }}>
        <Link
          component={RouterLink}
          to="/monthly-stats"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            fontWeight: 600,
          }}
        >
          View All Monthly Stats
          <ArrowForwardIcon fontSize="small" />
        </Link>
      </Box>

      {/* Fullscreen image dialog */}
      <Dialog
        fullScreen={isMobile}
        open={Boolean(selected)}
        onClose={() => setSelected(null)}
        TransitionComponent={Transition}
        maxWidth="md"
        fullWidth
      >
        <AppBar position="relative" color="primary">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setSelected(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" sx={{ ml: 2, flex: 1 }}>
              {selected?.title}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 0, bgcolor: "black" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: { xs: 1, sm: 1.5 },
            }}
          >
            <Box
              component="img"
              src={selected?.fullSrc}
              alt={selected?.title}
              sx={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
